module.exports = __webpack_public_path__ + "static/media/victorymusic.f90dc468.mp3";